export const colors = {
	primary: '#144722',
	white: '#ffffff',
	red: 'red',
	green: 'green',
};
